module.exports = __webpack_public_path__ + "static/media/sen manager.511086fe.svg";